import {
  ConfirmPaymentConfirmPaymentDocument,
  ConfirmPaymentConfirmPaymentMutation,
  ConfirmPaymentConfirmPaymentMutationVariables,
} from '../../graphql'

import { ConfirmPaymentOptions, PaymentAPI } from '../../typings/Payment'

const confirmPayment = async (paymentAPI: PaymentAPI, { pspPaymentMethodId, paymentId }: ConfirmPaymentOptions) => {
  const { data, errors } = (await paymentAPI.apolloClient.mutate<
    ConfirmPaymentConfirmPaymentMutation,
    ConfirmPaymentConfirmPaymentMutationVariables
  >({
    mutation: ConfirmPaymentConfirmPaymentDocument,
    variables: { paymentId, pspPaymentMethodId },
  })) as { data?: ConfirmPaymentConfirmPaymentMutation; errors?: Array<Error> }

  if (errors) {
    throw new Error(errors[0].message)
  }

  if (!data) {
    throw new Error('Missing confirm payment data')
  }

  return data.confirmPaymentWithPaymentMethod
}

export default confirmPayment
